import {mapGetters, mapActions} from 'vuex'

/* CRUD mixin to be used for order and article order management */
export default {
  computed: {
    ...mapGetters({
      curtainType: 'order/getCurtainType',
      curtainParameters: 'order/getCurtainParameters',
      railRodType: 'order/getRailRodType',
      railRodParameters: 'order/getRailRodParameters',
      room: 'order/getRoom',
      orderId: 'order/getOrderId'
    }),
  },
  methods: {
    ...mapActions({
      resetOrder: 'order/resetOrder'
    })
  }
}
